import React from 'react';
import {MenuItemRendererBase} from "../../menu-items-common/renderer/menu-item-renderer-base";
import {TabsNavigationItem} from '../../../components/tabs-navigation/tabs-navigation-item.component';

export class GenericTabsNavigationItemRenderer extends MenuItemRendererBase {

    protected _createReactElement(): React.ReactElement {
        return (<TabsNavigationItem key={this.key} menuItem={this}/>);
    }
}